import { AxiosProgressEvent } from 'axios';

import { ApiErrorData, ApiResponse } from '../models/ApiResponse';
import { VerticalService as VerticalServiceModel } from '../models/VerticalService';
import { FunctionsHelper } from '../utils/FunctionsHelper';
import MainBackendAxios from '../utils/MainBackendAxios';

export const VerticalService = {
  getByCurrentCompany: async (): Promise<
    ApiResponse<VerticalServiceModel[] | ApiErrorData>
  > => {
    try {
      const response = await MainBackendAxios.get(
        `/vertical-service/get-by-current-country`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getAll: async (): Promise<
    ApiResponse<VerticalServiceModel[] | ApiErrorData>
  > => {
    try {
      const response = await MainBackendAxios.get(`/vertical-service/get-all`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  findById: async (
    id: number
  ): Promise<ApiResponse<VerticalServiceModel | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(
        `/vertical-service/find-by-id/${id}`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  create: async (
    params: CreateVerticalServiceRequestDto
  ): Promise<ApiResponse<{ createdId: number } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/vertical-service/create`,
        params
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  update: async (
    id: number,
    params: UpdateVerticalServiceRequestDto
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(
        `/vertical-service/update/${id}`,
        params
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  delete: async (
    id: number
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.delete(
        `/vertical-service/delete/${id}`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  uploadLogoFile: async (
    formData: FormData,
    onProgress?: (progressEvent: AxiosProgressEvent) => void
  ): Promise<ApiResponse<{ url: string } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/vertical-service/upload-logo-file`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: onProgress,
        }
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  uploadPositions: async (
    ids: number[]
  ): Promise<ApiResponse<{ rowsUpdated: number } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/vertical-service/update-positions`,
        { ids }
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};

interface CreateVerticalServiceRequestDto {
  countryCode: string;
  name: string;
  title: string;
  description: string;
  logoUrl: string | null;
  mainContactName: string;
  mainContactDialCode: string;
  mainContactPhone: string;
  mainContactEmail: string;
  additionalData: {
    primaryColor: string;
  };
}

interface UpdateVerticalServiceRequestDto {
  name: string;
  title: string;
  description: string;
  logoUrl: string | null;
  mainContactName: string;
  mainContactDialCode: string;
  mainContactPhone: string;
  mainContactEmail: string;
  additionalData: {
    primaryColor: string;
  };
}
